// layouts/Customization/components/BusinessObjectDetails.js
import React from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { grey } from '@mui/material/colors';
import ArgonSelect from 'components/ArgonSelect';

function BusinessObjectDetails({ businessObject, onClose }) {
  return (
    <Card>
      <ArgonBox p={3} display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <ArgonBox display="flex" alignItems="center" gap={1}>
          <ArgonTypography variant="h6">{businessObject.name}</ArgonTypography>
          <ArgonSelect
            ml={2}
            name="version"
            placeholder="Select Version"
            options={[{
              label: "1.0.0",
              value: "1.0.0",
            },
            {
              label: "2.0.0",
              value: "2.0.0",
            }]}
            sx={{ display: 'inline-flex' }}
          />
        </ArgonBox>
        <Button variant="contained" color="info" onClick={onClose}>
          Back to Business Objects
        </Button>
      </ArgonBox>
      <ArgonBox p={3}>
        <ArgonTypography variant="h6" fontWeight="bold" mb={2}>
          Records
        </ArgonTypography>
        <TableContainer component={Paper}>
          <Table aria-label="business object records table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                {businessObject.columns.map((column, index) => (
                  <TableCell key={index} sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>
                    {column.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {businessObject.records.map((record, index) => (
                <TableRow key={index}>
                  {businessObject.columns.map((column, colIndex) => (
                    <TableCell key={colIndex}>{record[column.name]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ArgonBox>
    </Card>
  );
}

export default BusinessObjectDetails;
